export default __webpack_public_path__ + "static/nasdaq-240-9b7b5e1575a4c752029c0cf9b4b6329d.png";